export const tabValue1 = [{
	value1: {
		v1: 106,
		v2: '2.31',
		v3: '1.62',
	},
	value2: {
		v1: 101,
		v2: '0.92',
		v3: '0.88',
	},
	value3: {
		v1: '95.28',
		v2: '0.81',
		v3: '0.00',
	},
	value4: {
		v1: '0.12',
		v2: '0.80',
		v3: [{
			label: '17#月度防火计划BARW20250706000010',
			taskNo: 'BARW20250706000010',
			status: '已逾期'
		}, {
			label: '16#月度防火计划BARW20250706000009',
			taskNo: 'BARW20250706000009',
			status: '已逾期'
		}, {
			label: '12#月度防火计划BARW20250706000004',
			taskNo: 'BARW20250706000004',
			status: '已逾期'
		}],
	},
}, {
	value1: {
		v1: 99,
		v2: '0.12',
		v3: '0.08',
	},
	value2: {
		v1: 97,
		v2: '0.02',
		v3: '0.01',
	},
	value3: {
		v1: '97.97',
		v2: '0.02',
		v3: '0.01',
	},
	value4: {
		v1: '0.00',
		v2: '0.00',
		v3: [],
	},
}, {
	value1: {
		v1: 7,
		v2: '0.00',
		v3: '0.00',
	},
	value2: {
		v1: 4,
		v2: '0.00',
		v3: '0.00',
	},
	value3: {
		v1: '0.00',
		v2: '0.00',
		v3: '0.00',
	},
	value4: {
		v1: '0.00',
		v2: '0.00',
		v3: [{
			label: '17#月度防火计划BARW20250706000010',
			taskNo: 'BARW20250706000010',
			status: '已逾期'
		}, {
			label: '16#月度防火计划BARW20250706000009',
			taskNo: 'BARW20250706000009',
			status: '已逾期'
		}, {
			label: '12#月度防火计划BARW20250706000004',
			taskNo: 'BARW20250706000004',
			status: '已逾期'
		}],
	},
}, {
	value1: {
		v1: 0,
		v2: '0.00',
		v3: '0.00',
	},
	value2: {
		v1: 0,
		v2: '0.00',
		v3: '0.00',
	},
	value3: {
		v1: '0.00',
		v2: '0.00',
		v3: '0.00',
	},
	value4: {
		v1: '0.00',
		v2: '0.00',
		v3: [],
	},
}]



export const tabValue3 = [{
	value1: {
		v1: 38,
		v2: '2.31',
		v3: '1.62',
	},
	value2: {
		v1: 38,
		v2: '2.22',
		v3: '1.32',
	},
	value3: {
		v1: '100.00',
		v2: '0.00',
		v3: '0.00',
	},
	value4: {
		v1: '0.00',
		v2: '0.80',
		v3: [],
	},
}, {
	value1: {
		v1: 38,
		v2: '0.09',
		v3: '0.04',
	},
	value2: {
		v1: 38,
		v2: '0.02',
		v3: '0.01',
	},
	value3: {
		v1: '100.00',
		v2: '0.00',
		v3: '0.00',
	},
	value4: {
		v1: '0.00',
		v2: '0.00',
		v3: [],
	},
}, {

	value1: {
		v1: 0,
		v2: '0.00',
		v3: '0.00',
	},
	value2: {
		v1: 0,
		v2: '0.00',
		v3: '0.00',
	},
	value3: {
		v1: '0.00',
		v2: '0.00',
		v3: '0.00',
	},
	value4: {
		v1: '0.00',
		v2: '0.00',
		v3: [],
	},
}, {
	value1: {
		v1: 0,
		v2: '0.00',
		v3: '0.00',
	},
	value2: {
		v1: 0,
		v2: '0.00',
		v3: '0.00',
	},
	value3: {
		v1: '0.00',
		v2: '0.00',
		v3: '0.00',
	},
	value4: {
		v1: '0.00',
		v2: '0.00',
		v3: [],
	},
}]


export const tableValue3 = []


export const contentValue = [{
	v1: [69, 4, 0, 0],
	v1Value: [{
		label: '17#月度防火计划BARW20250706000010',
		taskNo: 'BARW20250706000010',
		status: '未完成'
	}, {
		label: '16#月度防火计划BARW20250706000009',
		taskNo: 'BARW20250706000009',
		status: '未完成'
	}, {
		label: '14#月度防火计划BARW20250706000008',
		taskNo: 'BARW20250706000008',
		status: '未完成'
	}, {
		label: '12#月度防火计划BARW20250706000004',
		taskNo: 'BARW20250706000004',
		status: '未完成'
	}],
	v2: [5, 1, 0, 0],
	v2Value: [{
		label: '保洁巡查计划BJXC20250706000001',
		taskNo: 'BJXC20250706000001',
		status: '未完成'
	}],
	v3: [0, 0, 0, 0],
	v3Value: [],
	v4: [32, 0, 0, 0],
	v4Value: [],
}, {
	v1: [62, 4, 0, 0],
	v1Value: [{
		label: '17#月度防火计划BARW20250706000010',
		taskNo: 'BARW20250706000010',
		status: '未完成'
	}, {
		label: '16#月度防火计划BARW20250706000009',
		taskNo: 'BARW20250706000009',
		status: '未完成'
	}, {
		label: '14#月度防火计划BARW20250706000008',
		taskNo: 'BARW20250706000008',
		status: '未完成'
	}, {
		label: '12#月度防火计划BARW20250706000004',
		taskNo: 'BARW20250706000004',
		status: '未完成'
	}],
	v2: [4, 0, 0, 0],
	v2Value: [],
	v3: [0, 0, 0, 0],
	v3Value: [],
	v4: [30, 0, 0, 0],
	v4Value: [],
}, {
	v1: [7, 0, 0, 0],
	v1Value: [],
	v2: [1, 1, 0, 0],
	v2Value: [{
		label: '保洁巡查计划BJXC20250706000001',
		taskNo: 'BJXC20250706000001',
		status: '未完成'
	}],
	v3: [0, 0, 0, 0],
	v3Value: [],
	v4: [2, 0, 0, 0],
	v4Value: [],
}, {
	v1: [0, 0, 0, 0],
	v1Value: [],
	v2: [0, 0, 0, 0],
	v2Value: [],
	v3: [0, 0, 0, 0],
	v3Value: [],
	v4: [0, 0, 0, 0],
	v4Value: [],
}]